const mTheHeaderSubMenuDropDownUser = {
  mTheHeaderSubMenuDropDownUser: {
    options: {
      account: 'Datos de Perfil',
      changeAcademy: 'Cambiar Academia',
      createAcademy: 'Crear Academia',
      language: 'Cambiar Idioma',
      logout: 'Salir de Vidroop',
      payments: 'Pagos a Vidroop',
      security: 'Seguridad',
      support: 'Contactar a Soporte',
      university: 'Universidad'
    }
  }
}

export default mTheHeaderSubMenuDropDownUser
